<template>
  <div class="font-jumper">
    <b-row>
      <b-col class="col-12 col-md-6 pt-4">
        <div class="inputLabel">Előnézet</div>

        <div v-if="thumbnail">
          <div class="thumbnailContainer">
            <img
                class=""
                :src="getImgFromByteArray(thumbnail.content)"
            />
          </div>
          <div class="thumbnailFunctions d-flex justify-content-between">
            <b-form-input v-model="details.fileName" :disabled="true"/>
            <b-button variant="secondary" class="circleBtn ml-2" @click="prevPage" v-if="thumbnail.numberOfPages > 1">
              <i class="fa fal fa-chevron-left"></i>
            </b-button>
            <b-button variant="secondary" class="circleBtn ml-2" @click="nextPage" v-if="thumbnail.numberOfPages > 1">
              <i class="fa fal fa-chevron-right"></i>
            </b-button>
            <b-button variant="secondary" class="circleBtn ml-2" @click="downloadFile">
              <i class="fa fal fa-download"></i>
            </b-button>
          </div>
        </div>

        <div class="mt-4">
          <b-row>
            <b-col cols="6">
              <div class="inputLabel">Címke</div>
              <Dropdown
                v-model="details.pwaTagId"
                :options="listByCompany"
                class="yellow-select uploaderSelect lightInputs"
                @input="updatePwaTag"
              />
            </b-col>
            <b-col cols="6">
              <div class="inputLabel">Tárgyidőszak</div>
              <b-form-input v-model="formattedPerformanceDate" :disabled="true"/>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <div class="inputLabel">Feltöltés időpontja</div>
              <b-form-input v-model="formattedUploadTime" :disabled="true"/>
            </b-col>
            <b-col cols="6">
              <div class="inputLabel">Státusz</div>
              <b-form-input v-model="details.status" :disabled="true"/>
            </b-col>
          </b-row>
        </div>

      </b-col>
      <b-col class="col-12 col-md-6 pt-4">

        <div class="inputLabel">Számlaszám</div>
        <b-form-input v-model="details.invoiceNumber" :disabled="true"/>

        <h4 class="mt-3 mb-2 ml-3">Eladó</h4>

        <div class="inputLabel">Név</div>
        <b-form-input v-model="details.sellerName" :disabled="true"/>

        <div class="inputLabel">Cím</div>
        <b-form-input v-model="details.sellerAddress" :disabled="true"/>

        <b-row>
          <b-col cols="6">
            <div class="inputLabel">Adószám</div>
            <b-form-input v-model="details.sellerTaxNumber" :disabled="true"/>
          </b-col>
          <b-col cols="6">
            <div class="inputLabel">Közösségi adószám</div>
            <b-form-input v-model="details.sellerEuTaxNumber" :disabled="true"/>
          </b-col>
        </b-row>

        <h4 class="mt-3 mb-2 ml-3">Vevő</h4>

        <div class="inputLabel">Név</div>
        <b-form-input v-model="details.buyerName" :disabled="true"/>

        <div class="inputLabel">Cím</div>
        <b-form-input v-model="details.buyerAddress" :disabled="true"/>

        <b-row>
          <b-col cols="6">
            <div class="inputLabel">Adószám</div>
            <b-form-input v-model="details.buyerTaxNumber" :disabled="true"/>
          </b-col>
          <b-col cols="6">
            <div class="inputLabel">Közösségi adószám</div>
            <b-form-input v-model="details.buyerEuTaxNumber" :disabled="true"/>
          </b-col>
        </b-row>

        <h4 class="my-4 ml-3">Fizetés</h4>

        <b-row>
          <b-col cols="6">
            <div class="inputLabel">Fizetési mód</div>
            <b-form-input v-model="details.paymentMethod" :disabled="true"/>
          </b-col>
          <b-col cols="6">
            <div class="inputLabel">Teljesítés dátuma</div>
            <b-form-input v-model="details.performanceDate" :disabled="true"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <div class="inputLabel">Kiállítás dátuma</div>
            <b-form-input v-model="details.invoiceDate" :disabled="true"/>
          </b-col>
          <b-col cols="6">
            <div class="inputLabel">Fizetési határidő</div>
            <b-form-input v-model="details.paymentDueDate" :disabled="true"/>
          </b-col>
        </b-row>

        <h4 class="my-4 ml-3">Összesen</h4>

        <b-row>
          <b-col cols="6">
            <b-form-input v-model="details.grossTotal" :disabled="true"/>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="details.currency" :disabled="true"/>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
  </div>
</template>
<script>
import Api from "api-client";
import Dropdown from "@/components/Dropdown.vue";
import {mapGetters} from "vuex";

export default {
  name: "DocumentDetails",

  props: {
    id: {
      type: String,
    },
  },

  components: {
    Dropdown
  },

  data() {
    return {
      details: {},
      thumbnail: {},
      currentPage: 0,
      listByCompany: [],
    }
  },
  methods: {

    updatePwaTag(){
      Api.overrideAppTagRequest(this.id, this.details.pwaTagId)
          .then(() => {
            this.$toast.success({
              message: 'A dokumentum címkéje sikeresen módosítva'
            });
          })
          .catch(error => {
            console.error("Error:", error);
          });
    },

    getListByCompany(){
      Api.getAvailableTags(this.getActiveCompany.id)
          .then(response => {
            response.data.forEach((data) => {
              if (!data.isDateRelated) {
                this.listByCompany.push({
                  value: data.id,
                  text: data.name,
                });
              }
            });
          })
          .catch(error => {
            console.error("Error fetching list by company:", error);
          });
    },

    downloadFile(){
      Api.getDocumentThumbnail(this.id, this.currentPage, true)
          .then(response => {
            const byteCharacters = atob(response.data.content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: response.data.contentType || 'application/octet-stream' });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = this.details.fileName + '.jpg';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
            }, 100);
          })
          .catch(error => {
            console.error("Error downloading document:", error);
            this.$toast.error({
              title: "Hiba történt",
              message: "A fájl letöltése nem sikerült"
            });
          });
    },

    nextPage(){
      if (this.currentPage < this.thumbnail.numberOfPages - 1) {
        this.currentPage += 1;
        this.getDocumentThumbnail();
      }
    },

    prevPage(){
      if (this.currentPage > 0) {
        this.currentPage -= 1;
        this.getDocumentThumbnail();
      }
    },

    getImgFromByteArray(encoded) {
      return "data:image/png;base64," + encoded;
    },

    getKnownDocument() {
      Api.getKnownDocument(this.id)
          .then(response => {
            this.details = response.data;
          })
          .catch(error => {
            console.error("Error fetching attached documents:", error);
          });
    },

    getDocumentThumbnail() {
      Api.getDocumentThumbnail(this.id, this.currentPage)
          .then(response => {
            this.thumbnail = response.data;
          })
          .catch(error => {
            console.error("Error fetching attached documents:", error);
          });
    },
  },
  created() {
    this.getListByCompany();
    this.getKnownDocument();
    this.getDocumentThumbnail();
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
    formattedPerformanceDate() {
      const date = new Date(this.details.performanceDate);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    },
    formattedUploadTime() {
      const date = new Date(this.details.uploadTime);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
  },
}
</script>

<style scoped>
.inputLabel {
  margin-left: 16px;
  margin-bottom: 8px;
}

.thumbnailContainer {
  width: 100%;
  height: 705px;
  overflow: hidden;
  border-radius: 32px;
  box-shadow: 0px 20px 30px 0px #0000001A;
  background-color: white;
}

.thumbnailContainer img {
  width: 100%;
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

.thumbnailFunctions {
  position: absolute;
  width: 90%;
  margin-top: -75px !important;
  margin-left: 10px;
  padding: 10px;
  background-color: white;
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  box-shadow: 0px 20px 30px 0px #0000001A;
}

.thumbnailFunctions input {
  margin-bottom: 0px !important;
}

.circleBtn {
  width: 60px !important;
  height: 40px !important;
  text-align: center !important;
  font-size: 14px !important;
  //box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.2) !important;
  padding: 0px !important;
  border: 1px solid #AEBFC7 !important;
}
</style>
